import React from 'react'
import PropTypes from 'prop-types'
import styled, { css, keyframes } from 'styled-components'
import CheckCircle from 'react-feather/dist/icons/check-circle'

import { ease } from '../globalStyles'

const popIn = keyframes`
from {
  transform: scale(1.5);
  opacity: 0;
}
`

const Message = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  opacity: 0;
  pointer-events: none;
  will-change: opacity, transform;
  transition: all 0.5s ${ease.popIn};
  animation: ${popIn} 0.3s ${ease.popIn};
  z-index: 1;
  font-size: 3rem;

  svg {
    width: 1.25em;
    height: 1.25em;
  }

  ${props =>
    props.visible &&
    css`
      opacity: 1;
      pointer-events: all;
    `};
`

class FullscreenMessage extends React.Component {
  static defaultProps = {
    duration: 1500
  }

  state = {
    messageToDisplay: this.props.message
  }

  timeoutID = null

  componentDidMount = () => {
    this.startTimeout()
  }

  componentWillReceiveProps = ({ message }) => {
    if (message) {
      this.setState({
        messageToDisplay: message
      })
    }
    this.startTimeout()
  }

  clearTimeout = () => {
    if (this.timeoutID) window.clearTimeout(this.timeoutID)
  }

  startTimeout = () => {
    this.clearTimeout()
    this.timeoutID = window.setTimeout(this.hide, this.props.duration)
  }

  componentWillUnmount = () => {
    this.clearTimeout()
  }

  hide = () => this.props.onComplete()

  render () {
    return (
      <Message onClick={this.hide} visible={!!this.props.message}>
        <CheckCircle />
        {this.state.messageToDisplay}
      </Message>
    )
  }
}

FullscreenMessage.propTypes = {
  onComplete: PropTypes.func.isRequired
}

export default FullscreenMessage



// WEBPACK FOOTER //
// ./src/components/FullscreenMessage.js